import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';


const routes: Routes = [
  { path: '', redirectTo: 'signin', pathMatch: 'full' }, // ROUTE TO PATIENT SURVEY FORM
  // { path: '', redirectTo: 'auth/login', pathMatch: 'full' }, //ROUTE TO SURVEY ADMIN PORTAL
  {
    path: 'homepage',
    loadChildren: () => import('./views/pages/_landing-page/landing-page/landing-page.module').then(m => m.LandingPageModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'survey-form',
    loadChildren: () => import('./views/pages/survey-form/survey-form.module').then(m => m.SurveyFormModule)
  },
  {
    path: 'survey-form-test',
    loadChildren: () => import('./views/pages/survey-form-test/survey-form.module').then(m => m.testSurveyFormModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./views/pages/sign-in/sign-in.module').then(m => m.SignInModule)
  },
  {
    path: 'register-password',
    loadChildren: () => import('./views/pages/register-password/register-password.module').then(m => m.RegisterPasswordModule)
  },
  // {
  //   path: 'email',
  //   loadChildren: () => import('./views/pages/email/email.module').then(m => m.EmailModule)
  // },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      // {
      //   path: 'dashboard',
      //   loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      // },
      //======================================================================================================================//
      {
        path: 'apps',
        loadChildren: () => import('./views/pages/apps/apps.module').then(m => m.AppsModule)
      },
      {
        path: 'ui-components',
        loadChildren: () => import('./views/pages/ui-components/ui-components.module').then(m => m.UiComponentsModule)
      },
      {
        path: 'advanced-ui',
        loadChildren: () => import('./views/pages/advanced-ui/advanced-ui.module').then(m => m.AdvancedUiModule)
      },
      {
        path: 'form-elements',
        loadChildren: () => import('./views/pages/form-elements/form-elements.module').then(m => m.FormElementsModule)
      },
      {
        path: 'advanced-form-elements',
        loadChildren: () => import('./views/pages/advanced-form-elements/advanced-form-elements.module').then(m => m.AdvancedFormElementsModule)
      },
      {
        path: 'charts-graphs',
        loadChildren: () => import('./views/pages/charts-graphs/charts-graphs.module').then(m => m.ChartsGraphsModule)
      },
      {
        path: 'tables',
        loadChildren: () => import('./views/pages/tables/tables.module').then(m => m.TablesModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/pages/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'general',
        loadChildren: () => import('./views/pages/general/general.module').then(m => m.GeneralModule)
      },
      ///////////////////////////////////////////////////////////////////////////////////////////////////

      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'survey',
        loadChildren: () => import('./views/pages/survey/survey.module').then(m => m.SurveyModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./views/pages/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'patients',
        loadChildren: () => import('./views/pages/patients/patients.module').then(m => m.PatientsModule)
      },
      {
        path: 'incidents',
        loadChildren: () => import('./views/pages/incidents/incidents.module').then(m => m.IncidentsModule)
      },
      {
        path: 'groups',
        loadChildren: () => import('./views/pages/group/group.module').then(m => m.GroupModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./views/pages/reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'email',
        loadChildren: () => import('./views/pages/email/email.module').then(m => m.EmailModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./views/pages/profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'export-report',
        loadChildren: () => import('./views/pages/export/export.module').then(m => m.ExportModule)
      },
      {
        path: 'survey-report',
        loadChildren: () => import('./views/pages/survey-report/survey-report.module').then(m => m.SurveyReportModule)
      },
      // { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Page Not Found',
      'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
